import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useState,
} from 'react';

import { appConfig } from '@/config';
import { LookerEnv } from '@/types/looker-env';

export const LookerEnvContext = createContext<
  [LookerEnv, Dispatch<SetStateAction<LookerEnv>>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);

export type LookerEnvProviderProps = PropsWithChildren<{}>;

export function LookerEnvProvider({ children }: LookerEnvProviderProps) {
  const state = useState<LookerEnv>(appConfig.defaultLookerEnv);

  return (
    <LookerEnvContext.Provider value={state}>
      {children}
    </LookerEnvContext.Provider>
  );
}
